export default __webpack_public_path__ + "static/media/RainierWolfcastle.a1693a9b.png";